import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal, Button, Icon, Loader, Progress } from 'semantic-ui-react';
import { PROMPT_PAY_TYPE, CARD_TYPE, IMBANK_TYPE } from "react-lib/apps/MEH/sequence/BillingAndPackage"
import jwt_encode from "jwt-encode";
import { jwtDecode } from 'jwt-decode';

type CardChoosePaidTypePackageModalProps = {
  BillingAndPackageSequence: any;
  runSequence: any;
  setProp: any;
  userProfile: any;
}

type SavePaymentCardProps = {
  creditcard: any;
  selected: boolean;
  onClick: () => void;
};

type PaymentCardProps = {
  method: any;
  selected: boolean;
  onClick: () => void;
};

const VISA_LOGO_PATH = "/images/Visa.svg"
const PROMPTH_PAY_PATH = "/static/images/promptpay.png"
const MASTERCARD_LOGO_PATH = "/images/Mastercard.svg"
const INTERNET_BANKING_PATH = "/images/InternetBanking.svg"
const CARD_ICON = '💳'

const PAYMENT_METHODS = [
  {
    id: CARD_TYPE,
    icon: '💳',
    iconBg: '#ffe5ec',
    title: 'บัตรเครดิต / บัตรเดบิต',
    logos: [VISA_LOGO_PATH, MASTERCARD_LOGO_PATH]
  },
  {
    id: PROMPT_PAY_TYPE,
    iconUrl: PROMPTH_PAY_PATH,
    iconBg: '#e3f2fd',
    title: 'คิวอาร์พร้อมเพย์',
    description: 'สแกนคิวอาร์โค้ดเพื่อจ่าย'
  },
  {
    id: IMBANK_TYPE,
    iconUrl: INTERNET_BANKING_PATH,
    iconBg: '#e3f2fd',
    title: 'อินเตอร์เน็ตแบงค์กิ้ง',
    description: 'Internet Banking'
  }
];

// Payment Method Code Mapping
export const PAYMENT_METHOD_MAP = [
  { code: "AO", description: "Atome" },
  { code: "A01", description: "Atome PayLater 1 month" },
  { code: "A03", description: "Atome PayLater 3 months" },
  { code: "A06", description: "Atome PayLater 6 months" },
  { code: "A12", description: "Atome PayLater 12 months" },
  { code: "AI", description: "AirPay" },
  { code: "AL", description: "Alipay / AlipayHK / Alipay+" },
  { code: "AM", description: "American Express" },
  { code: "AP", description: "Alternative Payment" },
  { code: "AT", description: "AppotaPay" },
  { code: "AY", description: "AyaPay" },
  { code: "BA", description: "BDO Pay" },
  { code: "BD", description: "BillDesk" },
  { code: "BH", description: "BOC Pay" },
  { code: "BL", description: "BillEase" },
  { code: "BO", description: "Boost" },
  { code: "BP", description: "BIDV PayPlus" },
  { code: "BT", description: "Bank Transfer" },
  { code: "CB", description: "CBPay" },
  { code: "CD", description: "CBDC QR" },
  { code: "DA", description: "Dash" },
  { code: "DF", description: "Dolfin" },
  { code: "DI", description: "Discover" },
  { code: "DK", description: "DANA" },
  { code: "DL", description: "DigitalMM" },
  { code: "DN", description: "Diners" },
  { code: "DP", description: "DBS PayLah" },
  { code: "DQ", description: "Dolfin QR" },
  { code: "DU", description: "DuitNow" },
  { code: "EA", description: "IQR Gateway - AirPay" },
  { code: "EAL", description: "QR Gateway - Alipay" },
  { code: "EAM", description: "QR Gateway - Amex" },
  { code: "EDN", description: "QR Gateway - Diners" },
  { code: "EJC", description: "QR Gateway - JCB" },
  { code: "ELP", description: "QR Gateway - LINE Pay" },
  { code: "EMA", description: "QR Gateway - MasterCard" },
  { code: "EPN", description: "QR Gateway - PayNow" },
  { code: "EQ", description: "QR Gateway (EMV QR)" },
  { code: "ETQ", description: "QR Gateway - Thai QR" },
  { code: "EUP", description: "QR Gateway - UnionPay" },
  { code: "EVI", description: "QR Gateway - Visa" },
  { code: "EWC", description: "QR Gateway - WeChat" },
  { code: "FP", description: "FavePay" },
  { code: "FPL", description: "FavePay Later" },
  { code: "FS", description: "HK FPS QR" },
  { code: "FN", description: "FNP" },
  { code: "GC", description: "GCash" },
  { code: "GP", description: "GrabPay" },
  { code: "G04", description: "GrabPay Installment 4 months" },
  { code: "G08", description: "GrabPay Installment 8 months" },
  { code: "G12", description: "GrabPay Installment 12 months" },
  { code: "GPC", description: "GrabPay Credit Card" },
  { code: "GPI", description: "GrabPay Installment" },
  { code: "GPP", description: "GrabPay Postpaid" },
  { code: "GO", description: "GoPay" },
  { code: "HC", description: "Home Credit" },
  { code: "HM", description: "Humm" },
  { code: "HO", description: "Hoolah" },
  { code: "ID", description: "Indodana" },
  { code: "I01", description: "Indodana 1 month" },
  { code: "I03", description: "Indodana 3 months" },
  { code: "I06", description: "Indodana 6 months" },
  { code: "I12", description: "Indodana 12 months" },
  { code: "JC", description: "JCB" },
  { code: "JK", description: "JKO Pay" },
  { code: "JP", description: "Jenius Pay" },
  { code: "KB", description: "KBZPay" },
  { code: "KD", description: "KCP Direct" },
  { code: "KH", description: "KHQR" },
  { code: "KK", description: "Kakao Pay" },
  { code: "KO", description: "JP Konbini" },
  { code: "KP", description: "KCP" },
  { code: "KS", description: "JP Seven Eleven" },
  { code: "KW", description: "KBZPay PWA" },
  { code: "KZ", description: "KBZ" },
  { code: "LA", description: "LinkAja" },
  { code: "LP", description: "LINE Pay" },
  { code: "LW", description: "Lazada Wallet" },
  { code: "LZ", description: "LazadaPay QR" },
  { code: "MA", description: "MasterCard" },
  { code: "MC", description: "MoPass / MOQR" },
  { code: "MD", description: "MPT" },
  { code: "ME", description: "M-Pesa" },
  { code: "MM", description: "MoMo" },
  { code: "MP", description: "MPU" },
  { code: "MV", description: "MyVIB" },
  { code: "MX", description: "MAXX" },
  { code: "MY", description: "MPay Vietnam" },
  { code: "NB", description: "NOBU QRIS" },
  { code: "NC", description: "NaverPay Credit Card" },
  { code: "NP", description: "NaverPay Point" },
  { code: "NV", description: "NaverPay" },
  { code: "OC", description: "OCBC Pay Anyone" },
  { code: "OK", description: "OK Dollar" },
  { code: "OP", description: "OnePay" },
  { code: "OT", description: "Octopus / OCTPay" },
  { code: "OV", description: "OVO" },
  { code: "PA", description: "PayPal" },
  { code: "PC", description: "Pace" },
  { code: "PE", description: "JP PayEasy" },
  { code: "PH", description: "PHQR" },
  { code: "PM", description: "PayMaya" },
  { code: "PN", description: "PayNow" },
  { code: "PO", description: "Payco" },
  { code: "PP", description: "PaoTang" },
  { code: "PS", description: "POS Credit Card" },
  { code: "PW", description: "PayPay" },
  { code: "PY", description: "PayMe" },
  { code: "RB", description: "RCBC" },
  { code: "RP", description: "RuPay" },
  { code: "SB", description: "ShopBack" },
  { code: "SBL", description: "ShopBack Later" },
  { code: "SBP", description: "ShopBack Pay" },
  { code: "SE", description: "SCB Easy" },
  { code: "SH", description: "ShopeePay" },
  { code: "SQ", description: "ShopeePay QR" },
  { code: "S01", description: "Shopee PayLater 1 months" },
  { code: "S02", description: "Shopee PayLater 2 months" },
  { code: "S03", description: "Shopee PayLater 3 months" },
  { code: "S04", description: "Shopee PayLater 4 months" },
  { code: "S05", description: "Shopee PayLater 5 months" },
  { code: "S06", description: "Shopee PayLater 6 months" },
  { code: "S12", description: "Shopee PayLater 12 months" },
  { code: "S18", description: "Shopee PayLater 18 months" },
  { code: "S24", description: "Shopee PayLater 24 months" },
  { code: "SM", description: "SmartPay" },
  { code: "SP", description: "SPAS" },
  { code: "SS", description: "SPay" },
  { code: "TA", description: "TripleA (Crypto)" },
  { code: "TG", description: "Touch 'n Go" },
  { code: "TN", description: "TendoPay" },
  { code: "TM", description: "TrueMoney" },
  { code: "TO", description: "TossPay" },
  { code: "TP", description: "TruePayNext" },
  { code: "TQ", description: "TrueMoney QR" },
  { code: "UA", description: "UATP" },
  { code: "UP", description: "UnionPay" },
  { code: "VC", description: "VTCCC" },
  { code: "VE", description: "ViettelPay" },
  { code: "VI", description: "Visa" },
  { code: "VN", description: "VINID" },
  { code: "VP", description: "VNPay" },
  { code: "VQ", description: "VNPay QR" },
  { code: "VT", description: "SVNQR" },
  { code: "VTV", description: "VTC Pay" },
  { code: "WA", description: "Wave" },
  { code: "WC", description: "WeChat" },
  { code: "WG", description: "Wing" },
  { code: "WH", description: "WeChat HK" },
  { code: "WQ", description: "WeChat QR (C scan B)" },
  { code: "WS", description: "WeChat Scan QR (B scan C)" },
  { code: "ZP", description: "ZaloPay" },
  { code: "ZQ", description: "ZaloPay QR" },
  { code: "BANKCOUNTER", description: "123 Bank Counter" },
  { code: "KIOSK", description: "123 Kiosk Machines" },
  { code: "IBANKING", description: "123 Internet Banking" },
  { code: "MOBILEBANKING", description: "123 Mobile Banking" },
  { code: "OVERTHECOUNTER", description: "123 Over the counter" },
  { code: "WEBPAY", description: "123 Web Payment" }
];

// Helper function to get description by code
const getPaymentMethodDescription = (code: string): string => {
  const method = PAYMENT_METHOD_MAP.find(m => m.code === code);
  return method ? method.description : code;
};

// Helper function to get code by description
const getPaymentMethodCode = (description: string): string => {
  const method = PAYMENT_METHOD_MAP.find(m => m.description === description);
  return method ? method.code : description;
};



const CardChoosePaidTypePackageModal = (props: CardChoosePaidTypePackageModalProps) => {
  const [selectedMethodId, setSelectedMethodId] = useState("");
  // const [qrCode, setQrCode] = useState("")
  // const [customerToken, setCustomerToken] = useState("")
  // const [showIframe, setShowIFrame] = useState(false)
  // const [token, setToken] = useState('');

  useEffect(() => {
    props.runSequence({
      sequence: "BillingAndPackage",
      action: "GET_PAID_CHOICE",
    })
  }, [])

  const onClose = () => {
    props.runSequence({
      sequence: "BillingAndPackage",
      action: "CLOSE_PAID_TYPE_PACKAGE",
    })
  }

  const payment_methods = useMemo(() => {

    // let paymentMethods: any[] = []
    // if (props.BillingAndPackageSequence?.paymentMethods?.items) {
    //   // TODO: filter payment methods
    //   let allowIds = props.BillingAndPackageSequence?.paymentMethods?.items?.map((i: any) => i.type)
    //   paymentMethods = PAYMENT_METHODS?.filter((i: any) => allowIds.includes(i.id))
    //   // TODO: Debug 
    //   if (props.userProfile?.id === 6832) {
    //     return PAYMENT_METHODS
    //   }
    // }

    return PAYMENT_METHODS

  }, [props.BillingAndPackageSequence?.paymentMethods])

  useEffect(() => {
    // มี invoice ปัจจุบัน 
    console.log('prepareInvoice: ', props.BillingAndPackageSequence?.transactions?.prepareInvoice);
    console.log('selectedMethodId: ', selectedMethodId);
    if (props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id) {
      if (selectedMethodId === PROMPT_PAY_TYPE) {


        // Show QRCode 
        // if (!qrCode) {
        //   let base64 = props.BillingAndPackageSequence?.paymentMethods?.items?.find((i: any) => i.type === selectedMethodId)?.qr_image_base64 || ""
        //   if (base64) {
        //     setQrCode(base64)
        //   }
        // }

        props.runSequence({
          sequence: "BillingAndPackage",
          action: "2C2P_SELECTED",
          type: "QR"
        })


      } else if (selectedMethodId === CARD_TYPE) {
        // Subscribe on post messages
        // window.addEventListener('message', handlePaymentPostMessages);
        props.runSequence({
          sequence: "BillingAndPackage",
          action: "2C2P_SELECTED",
          type: "CC"
        })
      } else if (selectedMethodId === IMBANK_TYPE) {
        props.runSequence({
          sequence: "BillingAndPackage",
          action: "2C2P_SELECTED",
          type: "IMBANK"
        })
      } else if (selectedMethodId) {
        props.runSequence({
          sequence: "BillingAndPackage",
          action: "2C2P_SELECTED",
          type: "CC",
          customerToken: selectedMethodId
        })
      }

      // set periodic checking 
      // props.runSequence({
      //   sequence: "BillingAndPackage",
      //   action: "START_PERIODIC_PAYMENT_CHECK",
      //   invoiceId: props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id
      // })
    }

  }, [props.BillingAndPackageSequence?.transactions?.prepareInvoice])

  const SavedPaymentCard = (saveCard: SavePaymentCardProps) => (
    <div
      onClick={saveCard.onClick}
      style={{
        border: saveCard.selected ? '2px solid #e91e63' : '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '1.5rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: saveCard.selected ? '#fff5f8' : 'white',
        transition: 'all 0.2s',
        marginBottom: '1rem'
      }}
    >

      {saveCard.creditcard?.payment_scheme.includes("AA") || saveCard.creditcard?.payment_scheme?.includes("MA") ? <div style={{
        width: '50px',
        height: '50px',
        backgroundColor: '#ffe5ec',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
      }}> <img
          src={saveCard.creditcard?.payment_scheme.includes("VI") ? VISA_LOGO_PATH : saveCard.creditcard?.payment_scheme?.includes("MA") ? MASTERCARD_LOGO_PATH : VISA_LOGO_PATH}
          alt="card"
          style={{ width: '30px' }}
        /> </div> : <div style={{
          width: '50px',
          height: '50px',
          backgroundColor: '#ffe5ec',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '1rem',
          fontSize: '1.5rem'
        }}>  {CARD_ICON} </div>}



      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.3rem' }}>
          {saveCard.creditcard.account_no}
        </div>
        {saveCard.creditcard.payment_scheme ? <div style={{ fontSize: '0.9rem', color: '#666' }}>
          {getPaymentMethodDescription(saveCard.creditcard.payment_scheme)}
        </div> : null}

      </div>

      <Icon name="check circle" size="large" style={{ color: saveCard.selected ? '#e91e63' : '#bbb' }} />
    </div>
  );




  const PaymentCard = (paymentcard: PaymentCardProps) => (
    <div
      onClick={paymentcard.onClick}
      style={{
        border: paymentcard.selected ? '2px solid #e91e63' : '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '1.5rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: paymentcard.selected ? '#fff5f8' : 'white',
        transition: 'all 0.2s',
        marginBottom: '1rem'
      }}
    >
      <div style={{
        width: '50px',
        height: '50px',
        backgroundColor: paymentcard.method.iconBg || '#f5f5f5',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '1rem',
        fontSize: '1.5rem'
      }}>
        {paymentcard.method.iconUrl ? <img width="25" height="25" src={`${paymentcard.method.iconUrl}`} /> : paymentcard.method.icon}
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '1rem', fontWeight: '500', marginBottom: '0.3rem' }}>
          {paymentcard.method.title}
        </div>
        {paymentcard.method.description && (
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            {paymentcard.method.description}
          </div>
        )}
        {paymentcard.method.logos && (
          <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {paymentcard.method.logos.map((logo, idx) => (
              <img
                key={idx}
                src={logo}
                alt="payment logo"
                style={{ height: logo.includes("Visa") ? '15px' : '20px', objectFit: 'contain' }}
              />
            ))}
          </div>
        )}
      </div>

      <Icon name="chevron right" size="large" style={{ color: '#bbb' }} />
    </div>
  );

  const handlePaymentAction = async () => {
    const currentInvoiceId = props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id;

    if (!currentInvoiceId) {
      await props.runSequence({
        sequence: "BillingAndPackage",
        action: "CREATE_INVOICE",
      });
    } else {
      await props.runSequence({
        sequence: "BillingAndPackage",
        action: "USE_EXISTING_INVOICE"
      });

      triggerPaymentMethod(selectedMethodId);
    }
  };

  const triggerPaymentMethod = (methodId: string) => {
    if (methodId === PROMPT_PAY_TYPE) {
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "2C2P_SELECTED",
        type: "QR",
      });
    } else if (methodId === CARD_TYPE) {
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "2C2P_SELECTED",
        type: "CC",
      });
    } else if (methodId === IMBANK_TYPE) {
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "2C2P_SELECTED",
        type: "IMBANK",
      });
    } else {
      // saved card / customer token
      props.runSequence({
        sequence: "BillingAndPackage",
        action: "2C2P_SELECTED",
        type: "CC",
        customerToken: methodId,
      });
    }
  };

  return (
    <Modal
      open={props.BillingAndPackageSequence.openPaidTypePackageModal}
      onClose={onClose}
      size="small"
      closeIcon
      closeOnDimmerClick={false}
    >
      <Modal.Header style={{ fontSize: '1.3rem' }}>
        เลือกช่องทางการชำระเงิน
      </Modal.Header>

      <Modal.Content>
        {props.BillingAndPackageSequence?.paymentMethods?.saveCreditCard?.items?.length > 0 && (
          <>
            <div style={{ marginBottom: '1rem', color: '#666', fontSize: '0.95rem' }}>
              วิธีการชำระเงินที่บันทึกไว้
            </div>

            {props.BillingAndPackageSequence?.paymentMethods?.saveCreditCard?.items?.map((creditcard) => (
              <SavedPaymentCard
                key={creditcard.id}
                creditcard={creditcard}
                selected={selectedMethodId === creditcard.customer_token}
                onClick={() => {
                  setSelectedMethodId(creditcard.customer_token)
                  // setCustomerToken(creditcard.customer_token)
                }}
              />
            ))}
            <br />
          </>
        )}

        <div style={{ marginBottom: '1rem', color: '#666', fontSize: '0.95rem' }}>
          ช่องทางแนะนำ
        </div>


        {payment_methods.map((method) => (
          <PaymentCard
            key={method.id}
            method={method}
            selected={selectedMethodId === method.id}
            onClick={() => {
              if (selectedMethodId === method.id) {
                setSelectedMethodId("")
              } else {
                setSelectedMethodId(method.id)
              }
            }
            }
          />
        ))}

        {/* {qrCode ? <div style={{ display: "flex", justifyContent: "center" }}> <br /> <img src={`data:image/png;base64,${qrCode}`} alt="Image" />  </div> : null}

        {qrCode ? <div> DEBUG: invoice Id: {props.BillingAndPackageSequence?.transactions?.prepareInvoice?.id} </div> : null}
        {qrCode ? <div> DEBUG: total_price_included_vat: {props.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat} </div> : null} */}

        {/* {props.BillingAndPackageSequence?.paymentCheckerPolling?.stop ? <div> Checking...</div> : null} */}
        {/* {showIframe && (
        <>
          <iframe
            ref={iframeRef}
            name="output_frame"
            id="output_frame"
            src={paymentUrl}
            width="800"
            height="600"
            style={{ border: '1px solid #ccc', marginTop: '20px' }}
            title="Payment Gateway"
          />
          <br />
          <button
            type="button"
            onClick={() => triggerSubmitPayment('submit_gcard')}
            style={{
              width: '200px',
              height: '80px',
              marginTop: '20px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            PAY NOW
          </button>
        </>
      )} */}

      </Modal.Content>
      {!!(props.BillingAndPackageSequence?.paymentCheckerPolling?.stop) ? <Progress style={{ borderRadius: 0 }} percent={100} attached='bottom' active /> : null}
      <Modal.Actions style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1.5rem'
      }}>
        <Button
          size="large"
          onClick={() => {
            props.runSequence({
              sequence: "BillingAndPackage",
              action: "BACK_TRANSACTION_SUMMARY",
            })
          }}
          style={{
            backgroundColor: '#9e9e9e',
            color: 'white',
            flex: 1,
            marginRight: '1rem'
          }}
        >
          ย้อนกลับ
        </Button>
        <Button
          size="large"
          disabled={(!selectedMethodId) ||
            !!props.BillingAndPackageSequence?.paymentCheckerPolling?.stop ||
            props.BillingAndPackageSequence?.transactions?.creatingInvoice
          }
          // onClick={async () => {

          //   // Create Invoice 
          //   await props.runSequence({ sequence: "BillingAndPackage", action: "CREATE_INVOICE" })

          // }}
          onClick={handlePaymentAction}
          style={{
            backgroundColor: selectedMethodId ? '#e91e63' : '#ccc',
            color: 'white',
            flex: 1.5
          }}
        >
          ดำเนินการชำระเงิน
        </Button>
      </Modal.Actions>
    </Modal>
  );
};



export default CardChoosePaidTypePackageModal;